module.exports = __webpack_public_path__ + "static/media/rep.3e589056.svg";